export default "__VITE_ASSET__Bgy9fD2F__"